/**
 *  @class
 *  @function SlideShow
 */
if (!customElements.get('slide-show')) {
  class SlideShow extends HTMLElement {
    constructor() {
      super();
      const slideshow = this,
        dataset = slideshow.dataset;

      let dots = dataset.dots === 'true',
        slideshow_slides = Array.from(slideshow.querySelectorAll('.carousel__slide')),
        autoplay = dataset.autoplay == 'false' ? false : parseInt(dataset.autoplay, 10),
        align = dataset.align == 'center' ? 'center' : 'left',
        fade = dataset.fade == 'true' ? true : false,
        show_navigation = dataset?.showNavigation === 'true' ? true : false,
        video_duration_autoplay = dataset?.videoDurationAutoplay === 'true',
        custom_dots = slideshow.querySelector('.flickity-page-dots'),
        animations = [],
        rightToLeft = document.dir === 'rtl',
        animations_enabled = document.body.classList.contains('animations-true') && typeof gsap !== 'undefined';

      if (slideshow_slides.length < 1) return;

      // Video duration autoplay handler - Flickity'den ÖNCE tanımla
      slideshow.currentAutoplayTimeout = null;
      slideshow.handleVideoAutoplay = (flkty, slideIndex) => {

        
        // Clear any existing timeout
        if (slideshow.currentAutoplayTimeout) {
          clearTimeout(slideshow.currentAutoplayTimeout);
          slideshow.currentAutoplayTimeout = null;
        }
        
        const currentSlide = flkty.cells[slideIndex].element;
        const videoElement = currentSlide.querySelector('video[data-video-duration]');
        
        let waitTime = autoplay; // Default olarak normal autoplay süresi
        let isVideoSlide = false;
        
        if (videoElement && videoElement.dataset.videoDuration) {
          const videoDuration = parseFloat(videoElement.dataset.videoDuration);
          if (videoDuration > 0) {
            waitTime = videoDuration * 1000;
            isVideoSlide = true;

          }
        } else {

        }
        
        // CSS --dot-speed property'sini güncelle
        const dotSpeedSeconds = waitTime / 1000;
        slideshow.style.setProperty('--dot-speed', dotSpeedSeconds + 's');

        
        // Dot animasyonu helper function
        const startDotAnimation = () => {
          const currentDot = slideshow.querySelector('.flickity-page-dots .dot.is-selected');
          if (currentDot) {
            // Önce animasyon class'ını kaldır
            currentDot.classList.remove('dot-animate');
            
            // Bir frame sonra animasyonu başlat
            requestAnimationFrame(() => {
              currentDot.classList.add('dot-animate');
            });
          }
        };
        
        if (isVideoSlide) {
          // Video slide'ında - video tam yüklenip başladıktan sonra timer başlat
          const videoContainer = currentSlide.querySelector('.slideshow__slide-video-bg');
          if (videoContainer) {
            // Video yüklenmesini bekle
            const startTimerWhenVideoReady = () => {

              // Timer başlatıldığında dot animasyonunu da başlat
              startDotAnimation();
              slideshow.currentAutoplayTimeout = setTimeout(() => {

                if (flkty.slides.length > 1) {
                  flkty.next();
                }
              }, waitTime);
            };
            
            // Eğer video zaten yüklenmişse hemen başlat
            if (videoContainer.classList.contains('loaded') || 
                (videoElement && videoElement.readyState >= 3)) {
              startTimerWhenVideoReady();
            } else {
              // Video yüklenmesini bekle
              if (videoElement) {
                const videoLoadHandler = () => {
                  videoElement.removeEventListener('canplay', videoLoadHandler);
                  videoElement.removeEventListener('loadeddata', videoLoadHandler);
                  startTimerWhenVideoReady();
                };
                videoElement.addEventListener('canplay', videoLoadHandler);
                videoElement.addEventListener('loadeddata', videoLoadHandler);
              } else {
                // External video (YouTube/Vimeo) için loaded class'ını bekle
                const observer = new MutationObserver((mutations) => {
                  mutations.forEach((mutation) => {
                    if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                      if (videoContainer.classList.contains('loaded')) {
                        observer.disconnect();
                        startTimerWhenVideoReady();
                      }
                    }
                  });
                });
                observer.observe(videoContainer, { attributes: true, attributeFilter: ['class'] });
                
                // Fallback - 2 saniye sonra başlat
                setTimeout(() => {
                  observer.disconnect();
                  if (!slideshow.currentAutoplayTimeout) {
                    startTimerWhenVideoReady();
                  }
                }, 2000);
              }
            }
          } else {
            // Video container yoksa normal timer

            startDotAnimation();
            slideshow.currentAutoplayTimeout = setTimeout(() => {
              
              if (flkty.slides.length > 1) {
                flkty.next();
              }
            }, waitTime);
          }
        } else {
          // Normal slide - hemen timer başlat

          startDotAnimation();
          slideshow.currentAutoplayTimeout = setTimeout(() => {

            if (flkty.slides.length > 1) {
              flkty.next();
            }
          }, waitTime);
        }
      };

      const args = {
        wrapAround: true,
        cellAlign: align,
        pageDots: dots,
        contain: true,
        fade: fade,
        adaptiveHeight: true,
        autoPlay: video_duration_autoplay ? false : autoplay, // Video duration aktifse Flickity autoplay'i kapat
        rightToLeft: rightToLeft,
        prevNextButtons: show_navigation && slideshow_slides.length > 1,
        cellSelector: '.carousel__slide',
        arrowShape: { 
          x0: 10,
          x1: 55, y1: 45,
          x2: 65, y2: 40,
          x3: 25
        },
        on: {}
      };

      if (slideshow_slides.length < 1) {
        return;
      }
      if (slideshow.classList.contains('image-with-text-slideshow--image')) {
        const image_slideshow_slides = slideshow.querySelectorAll('.image-with-text-slideshow--image-media');
        //args.draggable = false;

        if (image_slideshow_slides.length) {
          if (image_slideshow_slides[0].classList.contains('desktop-height-auto')) {
            args.adaptiveHeight = true;
          }
        }
      }
      if (slideshow.classList.contains('image-with-text-slideshow--content')) {
        args.draggable = false;
        args.asNavFor = slideshow.parentNode.querySelector('.image-with-text-slideshow--image');
        if (window.matchMedia('(min-width: 768px)').matches) {
          args.adaptiveHeight = false;
        }
      }
      if (slideshow.classList.contains('testimonials__carousel')) {
        args.adaptiveHeight = true;
      }
      if (slideshow.classList.contains('custom-dots')) {
        if (animations_enabled && slideshow.classList.contains('main-slideshow')) {
          this.prepareAnimations(slideshow, animations);
        }
        args.pauseAutoPlayOnHover = false;

        args.on = {
          staticClick: function () {
            this.unpausePlayer();
          },
          ready: function () {
            let flkty = this;
            // Animations.
            if (animations_enabled && slideshow.classList.contains('main-slideshow')) {
              slideshow.animateSlides(0, animations);
              gsap.set(slideshow.querySelectorAll('.inline-badge,.subheading,.split-text,.button'), { visibility: 'visible' });
            }

            // Custom Dots.
            if (custom_dots) {
              let dots = custom_dots.querySelectorAll('li');
              dots.forEach((dot, i) => {
                dot.addEventListener('click', () => flkty.select(i));
              });
              dots[this.selectedIndex].classList.add('is-selected');
              
              // İlk dot animasyonu handleVideoAutoplay tarafından başlatılacak
            }
            document.fonts.ready.then(function () {
              flkty.resize();
              if (args.adaptiveHeight) {
                flkty.setGallerySize();
              }
            });

            // Video Support - ilk slide için sadece görünür video'yu oynat
            const isMobileInit = window.matchMedia('(max-width: 767px)').matches;
            let video_container_init;
            
            if (isMobileInit) {
              // Mobilde önce mobil video'yu ara, yoksa desktop'ı kullan
              video_container_init = flkty.cells[0].element.querySelector('.slideshow__slide-video-bg.slideshow-video--mobile');
              if (!video_container_init) {
                video_container_init = flkty.cells[0].element.querySelector('.slideshow__slide-video-bg:not(.slideshow-video--desktop)');
              }
            } else {
              // Desktop'ta önce desktop video'yu ara, yoksa genel olanı kullan
              video_container_init = flkty.cells[0].element.querySelector('.slideshow__slide-video-bg.slideshow-video--desktop');
              if (!video_container_init) {
                video_container_init = flkty.cells[0].element.querySelector('.slideshow__slide-video-bg:not(.slideshow-video--mobile)');
              }
            }
            
            if (video_container_init) {
              const iframe = video_container_init.querySelector('iframe');
              const video = video_container_init.querySelector('video');
              if (iframe) {
                setTimeout(() => {
                  iframe.onload = () => slideshow.videoPlay(video_container_init);
                }, 100);
              } else if (video) {
                setTimeout(() => {
                  video.onloadstart = () => slideshow.videoPlay(video_container_init);
                }, 100);
              }
            }
                                      // İlk slide için autoplay başlat
            if (autoplay) {

                              if (video_duration_autoplay) {


                  slideshow.handleVideoAutoplay(flkty, 0);
                } else {

                // Normal Flickity autoplay zaten args'da set edildi, ek bir şey yapmaya gerek yok
              }
            }
          },
          change: function (index) {
            let flkty = this;
            flkty.cells[0].element.classList.remove('is-initial-selected');
            
            // DOĞRU: Önceki aktif slide'ı al (terk ettiğimiz slide)
            const previousSlideIndex = slideshow.currentSlideIndex;
            
            // Animations için eski hesaplama (animasyon sistemi için gerekli)
            let animationPreviousIndex = fizzyUIUtils.modulo(this.selectedIndex - 1, this.slides.length);

            // Animations.
            if (animations_enabled && slideshow.classList.contains('main-slideshow')) {
              setTimeout(() => {
                slideshow.animateReverse(animationPreviousIndex, animations);
              }, 700);
              slideshow.animateSlides(index, animations);
            }

            // Color changes.
            const selectedElement = this.selectedElement;
            const color_text = getComputedStyle(selectedElement).getPropertyValue('--color-body');
            const color_text_rgb = getComputedStyle(selectedElement).getPropertyValue('--color-body-rgb');
            slideshow.style.setProperty('--color-body', color_text);
            slideshow.style.setProperty('--color-body-rgb', color_text_rgb);

            // Custom Dots.
            if (custom_dots) {
              let dots = custom_dots.querySelectorAll('li');
              dots.forEach((dot, i) => {
                dot.classList.remove('is-selected', 'dot-animate');
              });
              dots[this.selectedIndex].classList.add('is-selected');
              
              // Yeni seçilen dot'un animasyonunu başlat
              const newDot = dots[this.selectedIndex];
              if (newDot) {
                // Bir frame sonra animasyonu başlat
                requestAnimationFrame(() => {
                  newDot.classList.add('dot-animate');
                });
              }
            }

            // AutoPlay
            if (autoplay && video_duration_autoplay) {
              slideshow.handleVideoAutoplay(flkty, index);
            }
            // Normal autoplay durumunda Flickity zaten otomatik handle ediyor

            // Video Support.
            // DOĞRU: Terk ettiğimiz slide'daki sadece görünür video'yu durdur
            if (previousSlideIndex !== undefined && previousSlideIndex !== null) {
              const isMobilePrev = window.matchMedia('(max-width: 767px)').matches;
              let video_container_prev;
              
              if (isMobilePrev) {
                // Mobilde önce mobil video'yu ara, yoksa desktop'ı kullan
                video_container_prev = flkty.cells[previousSlideIndex].element.querySelector('.slideshow__slide-video-bg.slideshow-video--mobile');
                if (!video_container_prev) {
                  video_container_prev = flkty.cells[previousSlideIndex].element.querySelector('.slideshow__slide-video-bg:not(.slideshow-video--desktop)');
                }
              } else {
                // Desktop'ta önce desktop video'yu ara, yoksa genel olanı kullan
                video_container_prev = flkty.cells[previousSlideIndex].element.querySelector('.slideshow__slide-video-bg.slideshow-video--desktop');
                if (!video_container_prev) {
                  video_container_prev = flkty.cells[previousSlideIndex].element.querySelector('.slideshow__slide-video-bg:not(.slideshow-video--mobile)');
                }
              }
              
              if (video_container_prev) {
                slideshow.videoStop(video_container_prev);
              }
            }
            
            // Terk ettiğimiz slide'ın ses butonunu sıfırla
            if (previousSlideIndex !== undefined && previousSlideIndex !== null) {
              slideshow.resetSoundButton(flkty.cells[previousSlideIndex].element);
            }
            
            // Şu anki aktif slide index'ini güncelle
            slideshow.currentSlideIndex = index;
            
            // current slide - sadece görünür olan video'yu oynat
            const isMobile = window.matchMedia('(max-width: 767px)').matches;
            let video_container;
            
            if (isMobile) {
              // Mobilde önce mobil video'yu ara, yoksa desktop'ı kullan
              video_container = flkty.cells[index].element.querySelector('.slideshow__slide-video-bg.slideshow-video--mobile');
              if (!video_container) {
                video_container = flkty.cells[index].element.querySelector('.slideshow__slide-video-bg:not(.slideshow-video--desktop)');
              }
            } else {
              // Desktop'ta önce desktop video'yu ara, yoksa genel olanı kullan
              video_container = flkty.cells[index].element.querySelector('.slideshow__slide-video-bg.slideshow-video--desktop');
              if (!video_container) {
                video_container = flkty.cells[index].element.querySelector('.slideshow__slide-video-bg:not(.slideshow-video--mobile)');
              }
            }
            
            if (video_container) {
              if (video_container.querySelector('iframe')) {
                if (video_container.querySelector('iframe').classList.contains('lazyload')) {
                  video_container.querySelector('iframe').addEventListener('lazybeforeunveil', slideshow.videoPlay(video_container));
                  lazySizes.loader.checkElems();
                } else {
                  slideshow.videoPlay(video_container);
                }
              } else if (video_container.querySelector('video')) {
                slideshow.videoPlay(video_container);
              }
            }

          }
        };
      }
      if (slideshow.classList.contains('main-slideshow')) {
        if (slideshow.classList.contains('desktop-height-image') || slideshow.classList.contains('mobile-height-image')) {
          args.adaptiveHeight = true;
        }
      }
      const flkty = new Flickity(slideshow, args);
      window.addEventListener('resize', () => {
        // mevcut hücre ve slide boyutlarını Flickity içerisinde güncelle
        flkty.resize();
        // adaptiveHeight aktifken viewport yüksekliğini güncelle
        if (args.adaptiveHeight) {
          flkty.setGallerySize();
        }
      });

      dataset.initiated = true;

      // Video Sound Toggle Functionality
      this.slideAudioStates = new Map(); // Her slide için ses durumunu sakla
      this.currentSlideIndex = 0; // Şu anki aktif slide index'ini takip et
      this.initVideoSoundToggle();

      if (Shopify.designMode) {
        slideshow.addEventListener('shopify:block:select', (event) => {
          const index = slideshow_slides.indexOf(event.target);
          // Clear timeout when manually selecting slide in theme editor (sadece video duration autoplay aktifse)
          if (video_duration_autoplay && slideshow.currentAutoplayTimeout) {
            clearTimeout(slideshow.currentAutoplayTimeout);
            slideshow.currentAutoplayTimeout = null;
          }
          flkty.select(index);
        });
      }

    }
    videoPause(video_container) {
      setTimeout(() => {
        if (video_container.dataset.provider === 'hosted') {
          video_container.querySelector('video').pause();
        } else {
          const iframe = video_container.querySelector('iframe');
          const message = iframe.dataset.provider === 'youtube' ? { event: "command", func: "pauseVideo", args: "" } : { method: "pause" };

          iframe.contentWindow.postMessage(JSON.stringify(message), "*");
        }
      }, 10);
      
      // Clear autoplay timeout when manually pausing (sadece video duration autoplay aktifse)
      if (this.dataset?.videoDurationAutoplay === 'true' && this.currentAutoplayTimeout) {
        clearTimeout(this.currentAutoplayTimeout);
        this.currentAutoplayTimeout = null;
      }
    }

    videoStop(video_container) {
      setTimeout(() => {
        if (video_container.dataset.provider === 'hosted') {
          const video = video_container.querySelector('video');
          if (video) {
            video.pause();
            video.currentTime = 0;
            video.muted = true; // Force mute
          }
        } else {
          const iframe = video_container.querySelector('iframe');
          if (iframe) {
            const provider = iframe.dataset.provider;
            // Stop video
            const stopMessage = provider === 'youtube' 
              ? { event: "command", func: "stopVideo", args: "" } 
              : { method: "pause" };
            iframe.contentWindow.postMessage(JSON.stringify(stopMessage), "*");
            
            // Force mute
            const muteMessage = provider === 'youtube' 
              ? { event: "command", func: "mute", args: "" }
              : { method: "setVolume", value: 0 };
            iframe.contentWindow.postMessage(JSON.stringify(muteMessage), "*");
          }
        }
        
        // Audio state'i sıfırla
        video_container.dataset.audioState = 'muted';
      }, 10);
    }

    resetSoundButton(slide) {
      const soundButton = slide.querySelector('.video-sound-btn');
      if (soundButton) {
        soundButton.dataset.videoSound = 'muted';
      }
      
      // Slide index'ini bul ve ses durumunu sıfırla
      const slideIndex = Array.from(slide.parentNode.children).indexOf(slide);
      this.slideAudioStates.set(slideIndex, false);
    }
    videoPlay(video_container) {
      setTimeout(() => {
        // Slide index'ini bul
        const slide = video_container.closest('.slideshow__slide');
        const slideIndex = Array.from(slide.parentNode.children).indexOf(slide);
        const shouldBeUnmuted = this.slideAudioStates.get(slideIndex) || false;
        
        if (video_container.dataset.provider === 'hosted') {
          const video = video_container.querySelector('video');
          video.play();
          // Video başladığında preview image'ı gizlemek için class ekle
          video_container.classList.add('loaded');
          
          // Ses durumunu restore et
          video.muted = !shouldBeUnmuted;
          video_container.dataset.audioState = shouldBeUnmuted ? 'unmuted' : 'muted';
          
        } else {
          const iframe = video_container.querySelector('iframe');
          const message = iframe.dataset.provider === 'youtube' ? { event: "command", func: "playVideo", args: "" } : { method: "play" };
          iframe.contentWindow.postMessage(JSON.stringify(message), "*");
          
          // Video başladığında preview image'ı gizlemek için class ekle
          video_container.classList.add('loaded');
          
          // Ses durumunu restore et  
          video_container.dataset.audioState = shouldBeUnmuted ? 'unmuted' : 'muted';
          
          // External video'lar için ses durumunu ayarla
          if (shouldBeUnmuted) {
            setTimeout(() => {
              const provider = video_container.dataset.provider;
              if (provider === 'youtube') {
                const unmuteMessage = { event: "command", func: "unMute", args: "" };
                iframe.contentWindow.postMessage(JSON.stringify(unmuteMessage), "*");
              } else if (provider === 'vimeo') {
                const unmuteMessage = { method: "setVolume", value: 1 };
                iframe.contentWindow.postMessage(JSON.stringify(unmuteMessage), "*");
              }
            }, 100); // Biraz gecikme ekle ki video önce başlasın
          }
        }
        
        // Ses butonunun durumunu güncelle
        this.updateSoundButtonState(slide, shouldBeUnmuted);
      }, 10);
    }
    prepareAnimations(slideshow, animations) {
      if (!slideshow.dataset.animationsReady) {
        new SplitText(slideshow.querySelectorAll('.split-text'), {
          type: 'lines',
          linesClass: 'line-child'
        });
        new SplitText(slideshow.querySelectorAll('.split-text'), {
          type: 'lines',
          linesClass: 'line-parent'
        });
        slideshow.querySelectorAll('.slideshow__slide').forEach((item, i) => {
          let tl = gsap.timeline({
            paused: true
          });

          animations[i] = tl;

          if (slideshow.dataset.transition == 'swipe') {
            tl
              .fromTo(item, {
                clipPath: 'polygon(0 0, 0 0, 0 100%, 0 100%)'
              }, {
                duration: 0.7,
                clipPath: 'polygon(0 0, 100% 0, 100% 100%, 0 100%)'
              }, "start");
          }
          tl
            .to(item.querySelector('.slideshow__slide-bg'), {
              duration: 1,
              scale: 1
            }, "start");
          tl
            .fromTo(item.querySelector('.inline-badge'), {
              opacity: 0
            }, {
              duration: 0.25,
              opacity: 1
            }, '>-=0.5');

          tl
            .fromTo(item.querySelector('.subheading'), {
              opacity: 0
            }, {
              duration: 0.25,
              opacity: 1
            }, '>-=0.3');
          tl
            .from(item.querySelectorAll('.slideshow__slide-content--heading .line-child'), {
              duration: 0.75,
              yPercent: 120,
              stagger: 0.1,
              rotation: '2deg'
            }, '>-=0.3');

          tl
            .from(item.querySelectorAll('p:not(.subheading) .line-child'), {
              duration: 0.5,
              yPercent: 120,
              stagger: 0.02,
              rotation: '2deg'
            }, '>-=0.3');
          tl
            .fromTo(item.querySelectorAll('.button'), {
              yPercent: 120,
              rotation: '2deg'
            }, {
              duration: 0.5,
              yPercent: 0,
              rotation: 0,
              stagger: 0.1,
            }, '>-=0.3');
          item.dataset.timeline = tl;
        });
        slideshow.dataset.animationsReady = true;
      }
    }
    animateSlides(i, animations) {
      animations[i].timeScale(1).restart();
    }
    animateReverse(i, animations) {
      animations[i].timeScale(4).reverse();
    }

    initVideoSoundToggle() {
      const soundButtons = this.querySelectorAll('.video-sound-btn');
      
      soundButtons.forEach(button => {
        button.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          
          const slide = button.closest('.slideshow__slide');
          const isMuted = button.dataset.videoSound === 'muted';
          
          // Toggle mute state - eğer şu anda muted ise unmute yap, değilse mute yap
          this.toggleVideoSound(slide, isMuted);
          
          // Save audio state for this slide
          const slideIndex = Array.from(slide.parentNode.children).indexOf(slide);
          this.slideAudioStates.set(slideIndex, isMuted); // isMuted ise unmute yapıldı, değilse mute yapıldı
          
          // Update button state (CSS will handle icon visibility)
          button.dataset.videoSound = isMuted ? 'unmuted' : 'muted';
        });
      });
    }

    toggleVideoSound(slide, unmute) {
      // Sadece görünür olan video container'ı seç (mobil veya desktop)
      const isMobile = window.matchMedia('(max-width: 767px)').matches;
      let videoContainer;
      
      if (isMobile) {
        // Mobilde önce mobil video'yu ara, yoksa desktop'ı kullan
        videoContainer = slide.querySelector('.slideshow__slide-video-bg.slideshow-video--mobile');
        if (!videoContainer) {
          videoContainer = slide.querySelector('.slideshow__slide-video-bg:not(.slideshow-video--desktop)');
        }
      } else {
        // Desktop'ta önce desktop video'yu ara, yoksa genel olanı kullan
        videoContainer = slide.querySelector('.slideshow__slide-video-bg.slideshow-video--desktop');
        if (!videoContainer) {
          videoContainer = slide.querySelector('.slideshow__slide-video-bg:not(.slideshow-video--mobile)');
        }
      }
      
      if (!videoContainer) return;
      
      // Aynı ses komutu tekrar gönderilmesin diye kontrol et
      const currentAudioState = videoContainer.dataset.audioState;
      const newAudioState = unmute ? 'unmuted' : 'muted';
      
      if (currentAudioState === newAudioState) {
        // Aynı durumdaysa komut gönderme
        return;
      }
      
      if (videoContainer.dataset.provider === 'hosted') {
        const video = videoContainer.querySelector('video');
        if (video) {
          video.muted = !unmute;
          videoContainer.dataset.audioState = newAudioState;
        }
      } else {
        // External video (YouTube/Vimeo)
        const iframe = videoContainer.querySelector('iframe');
        if (iframe) {
          const provider = videoContainer.dataset.provider;
          if (provider === 'youtube') {
            const message = unmute 
              ? { event: "command", func: "unMute", args: "" }
              : { event: "command", func: "mute", args: "" };
            iframe.contentWindow.postMessage(JSON.stringify(message), "*");
            videoContainer.dataset.audioState = newAudioState;
          } else if (provider === 'vimeo') {
            const message = unmute 
              ? { method: "setVolume", value: 1 }
              : { method: "setVolume", value: 0 };
            iframe.contentWindow.postMessage(JSON.stringify(message), "*");
            videoContainer.dataset.audioState = newAudioState;
          }
        }
      }
    }



    updateSoundButtonState(slide, shouldBeUnmuted) {
      const soundButton = slide.querySelector('.video-sound-btn');
      if (soundButton) {
        soundButton.dataset.videoSound = shouldBeUnmuted ? 'unmuted' : 'muted';
      }
    }




  }
  customElements.define('slide-show', SlideShow);
}